/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */

import React, {useState, useEffect} from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBox, faCashRegister, faChartLine, faCloudUploadAlt, faPlus, faRocket, faTasks, faUserAlt, faUserShield, faWallet } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Button, Dropdown, ButtonGroup, Card, Table, Form, Badge } from '@themesberg/react-bootstrap';

import { CounterWidget, CircleChartWidget, BarChartWidget, TeamMembersWidget, ProgressTrackWidget, RankingWidget, SalesValueWidget, SalesValueWidgetPhone, AcquisitionWidget } from "../../components/Widgets";
import { PageVisitsTable } from "../../components/Tables";
import {  totalOrders } from "../../data/charts";
import { useDispatch, useSelector } from "react-redux"
import _, { set } from "lodash"

import { faDeskpro } from "@fortawesome/free-brands-svg-icons";
import { getUser } from "../../core/auth/authentication";

import StatisticAction from "../../core/redux/action/StatisticAction";
import BalanceAction from "../../core/redux/action/BalanceAction";
import { currencyFormat } from "../../core/util/General";
import AppConfig from "../../core/config/AppConfig";
import moment from "moment"
import { TransactionStatus } from "../transaction/TransactionPage";
import { Routes } from "../../routes";
import { Link } from "react-router-dom";
import { GetResultObject, PostRequest, GetRequest } from "../../core/API";
import { ApiSrc } from "../../resources/ApiSrc";

export default () => {
  const [user, setUser] = useState()
  useEffect(()=> {
      getUser().then(it=>{
          setUser(it)
      })
  }, [])

  const dispatch = useDispatch();
  const statisticRes = useSelector((state) => state.statistic);
  const [mapWaybill, setMapWaybill] = useState()
  const [mapWallet, setMapWallet] = useState()

  const [startDate, setStartDate] = useState(moment().startOf('year'))
  const [endDate, setEndDate] = useState(moment().add(99, 'year').endOf('year'))
  const [filterBy, setFilterBy] = useState('all')
  const [reminderCount, setReminderCount] = useState(0)

  const balanceRec = useSelector((state) => state.balance);

  useEffect(()=>{

    GetRequest("https://notification.joonaakhub.com/notification/get_reminder?per_page=1", {}, {}).then(result=>{      
      console.log(">get_reminder", result)
      setReminderCount(_.get(result, 'data.paging.total'))      
    })

    if(user == undefined) return
    if(_.get(user, 'role') == 'Super Admin') {
      // if(_.get(statisticRes, 'userStatisticList.data') == undefined) {
        dispatch(StatisticAction.getUserStatistic({
          input: {
            startDate,
            endDate
          }
        }))
      // }
      
      // if(_.get(statisticRes, 'userStatisticList.data') == undefined) {
        dispatch(StatisticAction.getWallet({
          input: {
            startDate,
            endDate
          }
        }))
      // }

      if(_.get(balanceRec, 'balance') == undefined) {
        dispatch(BalanceAction.getBalance({}))
      }

      if(_.get(balanceRec, 'transactionList.data') == undefined) {
        dispatch(BalanceAction.getTransactions({token: null, input: {
          startDate,
            endDate
        }}, { 
          size: 5,
          sort: "createdAt,DESC",
          page: 0}))
      }
    }
    

    // if(_.get(statisticRes, 'waybillStatisticList.data') == undefined) {
      dispatch(StatisticAction.getWaybillStatistic({
        input: {
          startDate,
          endDate
        }
      }))
    // }

    
  }, [startDate, endDate, user])

  const [chinaTraffic, setChinaTraffic] = useState()
  const [thailandTraffic, setThailandTraffic] = useState()
  const [vietnamTraffic, setVietnamTraffic] = useState()

  useEffect(()=> {
    const mapWaybill = _.groupBy(_.get(statisticRes, 'waybillStatisticList.data', []), 'country_code')
    //console.log(">mapWaybill", mapWaybill)
    const kyes = ['86', '84', '66']
    kyes.map(key => {
      const mapWaybillByStatus= _.groupBy(mapWaybill[key], 'status')
      mapWaybill[key] = mapWaybillByStatus
      const row = [
        { 
          id: 1, 
          label: "Pending", 
          value: mapWaybillByStatus['Pending'] ? mapWaybillByStatus['Pending'][0].count : 0 ,
          color: "warning", 
          icon: faBox 
        },
        { 
          id: 1, 
          label: "Warehouse", 
          value: mapWaybillByStatus['Warehouse'] ? mapWaybillByStatus['Warehouse'][0].count : 0 ,
          color: "primary", 
          icon: faBox 
        },
        { 
          id: 1, 
          label: "Ready for Transit", 
          value: mapWaybillByStatus['Ready for Transit'] ? mapWaybillByStatus['Ready for Transit'][0].count : 0 ,
          color: "secondary", 
          icon: faBox 
        },
        { 
          id: 1, 
          label: "Transit", 
          value: mapWaybillByStatus['Transit'] ? mapWaybillByStatus['Transit'][0].count : 0 ,
          color: "info", 
          icon: faBox 
        },
        { 
          id: 1, 
          label: "Arrived", 
          value: mapWaybillByStatus['Arrived'] ? mapWaybillByStatus['Arrived'][0].count : 0 ,
          color: "success", 
          icon: faBox 
        },
        { 
          id: 1, 
          label: "Received", 
          value: mapWaybillByStatus['Received'] ? mapWaybillByStatus['Received'][0].count : 0 ,
          color: "danger", 
          icon: faBox 
        },        
      ]
      switch(key) {
        case '86' : setChinaTraffic(row); break
        case '66' : setThailandTraffic(row); break
        case '84' : setVietnamTraffic(row); break
      }
      
    })
    //setMapWaybill(mapWaybill)
    //console.log(">mapWaybill", mapWaybill)    
  }, [_.get(statisticRes, 'waybillStatisticList.data')])


  useEffect(()=> {
    if(_.get(statisticRes, 'wallet') == undefined) return       
    const wallets = _.get(statisticRes, 'wallet')       
    const mWallet = _.groupBy(_.get(statisticRes, 'wallet'), 'type') 
    console.log(">>> mWallet", mWallet, wallets)

    var shipment = 0;
    var joonaak = _.sumBy(_.get(mWallet, 'joonaak'), 'joonaak');
    var express = _.sumBy(_.get(mWallet, 'express'), 'joonaak');
    var pickup = _.sumBy(_.get(mWallet, 'pickup'), 'joonaak');
    var total = 0;

    _.get(statisticRes, 'wallet', []).map(item => {
      shipment += parseFloat(_.get(item, 'freight', 0))
      // total += parseFloat(_.get(item, 'total', 0))
    })
    
    // if(total == undefined || total == NaN) total = 0;
    var unpaid = _.sumBy(_.get(mWallet, 'unpaid'), 'total');;
    total = joonaak + express + pickup + shipment + unpaid;
    total += unpaid;
    setMapWallet({
      unpaid,
      shipment,
      joonaak,
      express,
      pickup,
      total
    })    
  }, [_.get(statisticRes, 'wallet')])

  return (
    <>
    <Row>        

        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">          
        <ButtonGroup>            
            <Button 
            className={filterBy == 'all' ? 'active' : ''}
            variant="outline-primary"  size="sm" onClick={() => { 
              setStartDate(moment().startOf('year'))
              setEndDate(moment().add(99, 'year').endOf('year'))
              setFilterBy('all')
             }}>All</Button>              
          
            <Button 
            className={filterBy == 'last month' ? 'active' : ''}
            variant="outline-primary"  size="sm" onClick={() => { 
              setStartDate(moment().subtract(1, 'month').startOf('month'))
              setEndDate(moment().subtract(1, 'month').endOf('month'))
              setFilterBy('last month')
             }}>Last Month</Button>              
            <Button 
            className={filterBy == 'last week' ? 'active' : ''}
            variant="outline-primary"  size="sm" onClick={() => { 
              setStartDate(moment().subtract(1, 'weeks').startOf('week'))
              setEndDate(moment().subtract(1, 'weeks').endOf('week'))
              setFilterBy('last week')
             }}>Last Week</Button>              
            <Button variant="outline-primary" 
              className={filterBy == 'today' ? 'active' : ''}
              size="sm" onClick={() => { 
              setStartDate(moment().startOf('day'))
              setEndDate(moment().endOf('day'))
              setFilterBy('today')
             }}>Today</Button>              
            <Button variant="outline-primary" size="sm" 
              className={filterBy == 'this week' ? 'active' : ''}
            onClick={() => {
              setStartDate(moment().startOf('week'))
              setEndDate(moment().endOf('week'))
              setFilterBy('this week')
              }}>This Week</Button>              
            <Button 
              className={filterBy == 'this month' ? 'active' : ''}
              variant="outline-primary" size="sm" onClick={() => { 
              
              setStartDate(moment().startOf('month'))
              setEndDate(moment().endOf('month'))
              setFilterBy('this month')
             }}>This Month</Button>              
            <Button 
            className={filterBy == 'this year' ? 'active' : ''}
              variant="outline-primary" size="sm" onClick={() => { 
              setStartDate(moment().startOf('year'))
              setEndDate(moment().endOf('year'))
              setFilterBy('this year')
             }}>This Year</Button>              
          </ButtonGroup>
        </div>
        <div className="btn-toolbar mb-2 mb-md-0">
        {
          _.get(user, 'countryCode') == '855' && (
            <ButtonGroup>
              <Button variant="outline-dark" size="sm" onClick={() => {
                PostRequest(ApiSrc.GET_SETTING, 
                  {
                    "input": {
                      "key": "notify_url"
                    }
                  }, {}).then(result => { GetResultObject(result, 'data', 200, data => {
                    //console.log(_.get(data, '[0].value'))
                    if(_.get(data, '[0].value')) {
                      window.open(_.get(data, '[0].value') , "_blank")
                    }                                    
                })})                
              }}>Send reminder<Badge pill bg={"info"} className="badge-md notification-count ms-2">{reminderCount}</Badge></Button>            
            </ButtonGroup>
          )
        }          
        </div>
      </div>       
    </Row>
    <br></br>
    <Row>
      {
        ((_.get(user, 'countryCode') == '855' || _.get(user, 'countryCode') == '86') && chinaTraffic) && 
        <Col xs={12} sm={6} xl={4} className="mb-4">
          <Card border="light" className="shadow-sm">
            <Card.Body>
              <CircleChartWidget
                title={`China ${_.sumBy(chinaTraffic, 'value')}`}
                data={chinaTraffic} />
            </Card.Body>
          </Card>
          
        </Col>
      
      } 
      {
        ((_.get(user, 'countryCode') == '855' || _.get(user, 'countryCode') == '66') && thailandTraffic) && 
        <Col xs={12} sm={6} xl={4} className="mb-4">
          <Card border="light" className="shadow-sm">
            <Card.Body>
              <CircleChartWidget
                title={`Thailand ${_.sumBy(thailandTraffic, 'value')}`}
                data={thailandTraffic} />
            </Card.Body>
          </Card>
          
        </Col>
      
      }
      {
        ((_.get(user, 'countryCode') == '855' || _.get(user, 'countryCode') == '84') && vietnamTraffic) && 
        <Col xs={12} sm={6} xl={4} className="mb-4">
          <Card border="light" className="shadow-sm">
            <Card.Body>
              <CircleChartWidget  
                title={`Vietnam ${_.sumBy(vietnamTraffic, 'value')}`}
                data={vietnamTraffic} />
            </Card.Body>
          </Card>          
        </Col>
      
      }
    </Row> 
      
      

      {
        

        (_.get(user, 'role') == 'Super Admin' && mapWallet ) && (
          <>
          

        <Row className="justify-content-md-center"> 

            <Col xs={12} xl={2} className="mb-4">                                           
            <Card border="light" className="mb-4">
              <Card.Body>
                    <Col className={"float-center"}>
                      <Form.Label><FontAwesomeIcon icon={faWallet}/> Unpaid</Form.Label>
                      <h6> ${ currencyFormat(_.get(mapWallet, '[unpaid]')) }</h6>
                    </Col>                                           
                </Card.Body>
              </Card>              
            </Col>                

            <Col xs={12} xl={2} className="mb-4">                                           
            <Card border="light" className="mb-4">
              <Card.Body>
                    <Col className={"float-center"}>
                      <Form.Label><FontAwesomeIcon icon={faWallet}/> Shipment</Form.Label>
                      <h6> ${ currencyFormat(_.get(mapWallet, '[shipment]')) }</h6>
                    </Col>                                           
                </Card.Body>
              </Card>              
            </Col>                

            <Col xs={12} xl={2} className="mb-4">
            <Card border="light" className="shadow-sm">
              <Card.Body>
                    <Col className={"float-center"}>
                      <Form.Label><FontAwesomeIcon icon={faWallet}/> Joonaak Fee</Form.Label>
                      <h6> ${ currencyFormat(_.get(mapWallet, '[joonaak]')) }</h6>
                      {/* <span>${ currencyFormat(_.get(mapWallet, '[pickup]')) }</span>                       */}
                    </Col>                                           
                </Card.Body>
              </Card>              
            </Col>    

            <Col xs={12} xl={2} className="mb-4">
            <Card border="light" className="shadow-sm">
              <Card.Body>
                    <Col className={"float-center"}>
                      <Form.Label><FontAwesomeIcon icon={faWallet}/> Express Fee</Form.Label>
                      <h6> ${ currencyFormat(_.get(mapWallet, '[express]')) }</h6>
                    </Col>                                           
                </Card.Body>
              </Card>              
            </Col>   
            
            <Col xs={12} xl={4} className="mb-3">
            <Card border="light" className="shadow-sm">
              <Card.Body>
                    <Col className={"float-center"}>
                      <Form.Label><FontAwesomeIcon icon={faWallet}/> Total</Form.Label>
                      <h6> ${ currencyFormat(_.get(mapWallet, '[total]')) }</h6>
                    </Col>                                           
                </Card.Body>
              </Card>              
            </Col>          
          </Row>
        </>)

      }

      {
        _.get(user, 'role') == 'Super Admin' && (
          
        
          <Row>
            <Col xs={12} xl={12} className="mb-4">
              <Row>
                <Col xs={12} className="mb-4">
                  <Card border="light" className="shadow-sm">
                  <Card.Header>
                    <Row className="align-items-center">
                      <Col>
                        <h5>Last Transactions</h5>
                      </Col>
                      <Col className="text-end">
                        <Button variant="secondary" as={Link} to={Routes.Transactions.path} size="sm">See all</Button>
                      </Col>
                    </Row>
                  </Card.Header>
                  <Table responsive className="align-items-center table-flush">
                    <thead className="thead-light">
                      <tr>
                        <th className="border-0">#</th>                                        
                        <th className="border-0">Date</th>                        
                        <th className="border-0">Transaction#</th>                        
                        <th className="border-0">Amount</th>                                         
                      </tr>
                    </thead>
                    <tbody>
                      {
                        _.get(balanceRec, 'transactionList.data') && _.get(balanceRec, 'transactionList.data').map((item, index) => {                          
                          return (
                            <tr>
                              <td>{(index + 1) + (AppConfig.pageSize * 0)}</td>                        
                              <td>{moment(_.get(item, 'createdAt')).format('MM-DD-YYY HH:mm')}</td>                            
                              <td>{_.get(item, 'transactionNo', '')}</td>                              
                              <td>
                                <span>
                                    <i className={`fa fa-sm ${_.get(item, 'transactionType')=='debited' ? 'fa-plus text-success' : 'fa-minus text-danger'} `}/>&nbsp;
                                    { _.replace(currencyFormat(_.get(item, 'amount', 0)), '-','') }
                                  </span>                                                    
                              </td>                                                        
                            </tr>
                          )
                        })
                      }
                    </tbody>
                  </Table>
                </Card>
                </Col>                                                                                          
            </Row>          
          </Col>    
          
        </Row>
        )
      }
      
      
      {
        _.get(user, 'role') == 'Super Admin' && (
          <Row className="justify-content-md-center">
          {
              _.get(statisticRes, 'userStatisticList.data', []).map(item => {
                return (
                  <Col xs={12} sm={6} xl={4} className="mb-4">
                    <CounterWidget
                      category={_.get(item, 'role')}
                      title={_.get(item, 'count')}
                      icon={faUserAlt}
                      iconColor="shape-secondary"
                    />
                  </Col>
                )            
              })
            }        
          </Row>
        )
      }
      
      {/* <Row>
        <Col xs={12} xl={12} className="mb-4">
          <Row>
            <Col xs={12} xl={8} className="mb-4">
              <Row>
                <Col xs={12} className="mb-4">
                  <PageVisitsTable />
                </Col>

                <Col xs={12} lg={6} className="mb-4">
                  <TeamMembersWidget />
                </Col>

                <Col xs={12} lg={6} className="mb-4">
                  <ProgressTrackWidget />
                </Col>
              </Row>
            </Col>

            <Col xs={12} xl={4}>
              <Row>
                <Col xs={12} className="mb-4">
                  <BarChartWidget
                    title="Total orders"
                    value={452}
                    percentage={18.2}
                    data={totalOrders} />
                </Col>

                <Col xs={12} className="px-0 mb-4">
                  <RankingWidget />
                </Col>

                <Col xs={12} className="px-0">
                  <AcquisitionWidget />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row> */}
    </>
  );
};


